<!--
 * @Description: 
 * @Date: 2020-07-28 10:26:24
 * @LastEditTime: 2020-07-28 11:07:27
--> 
<template>
  <div id="outcome-chart" ref="inc_chart" style="width:100%;height:300px;"></div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons");
export default {
  props: {
    Ldata: {
      type: Array,
      default() {
        return [];
      }
    },
    Xdata: {
      type: Array,
      default() {
        return [];
      }
    },
    Sdata: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      outChart: null //收入图表echart 实例
    };
  },
  mounted() {
    this.initInEchart();
  },
  methods: {
    initInEchart() {
      this.outChart = echarts.init(document.getElementById("outcome-chart"));
      this.outChart.setOption({
        title: {
          text: "支出趋势图"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.Ldata
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.Xdata 
        },
        yAxis: {
          type: "value"
        },
        series: this.Sdata
      });
    }
  }
};
</script>

<style>
</style>